export enum UserRole {
    Editor = 'datalens.editor',
    Admin = 'datalens.admin',
    Viewer = 'datalens.viewer',
    Visitor = 'datalens.visitor',
    Creator = 'datalens.creator',
}
